import React, { PropTypes } from "react"
import {
  FormGroup,
  ControlLabel,
  Button,
  Row,
  Col,
  Modal,
  HelpBlock
} from "react-bootstrap"
import Classnames from "classnames"
import numeral from "numeral"

// LOCAL
import CouponField from "./CouponField"
// SHARED
import { FieldGroup } from "../core/components/FieldGroup"
import { calculateDiscountFromStripeCoupon } from "../utils/AppHelper"

export default class UpdateSubscriptionModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = this.initialState()
  }

  initialState() {
    const { customer } = this.props

    return {
      coupon: {
        id: "",
        amount_off: "",
        percent_off: ""
      },
      quantity: this.props.quanity || 1
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    const { productIdentifier, isGroup } = this.props

    if (isGroup) {
      if (this.state.quantity != "") {
        this.props.onUpdateSubscriptionSubmit(
          productIdentifier,
          this.state.coupon.id,
          this.state.quantity
        )
        this.setState(this.initialState())
      }
    } else {
      this.props.onUpdateSubscriptionSubmit(
        productIdentifier,
        this.state.coupon.id,
        this.state.quantity
      )
      this.setState(this.initialState())
    }
  }

  handleChange(e) {
    let state = this.state
    if (e.target.name == "coupon") {
      state["coupon"]["id"] = e.target.value
    } else {
      state[e.target.name] = e.target.value
    }
    this.setState(state)
  }

  handleReceiveCouponSuccess(coupon_json) {
    let card = this.state.card
    let coupon = this.state.coupon
    let expiration = this.state.expiration

    coupon.amount_off = coupon_json.coupon.amount_off
    coupon.percent_off = coupon_json.coupon.percent_off

    let state = { card, expiration, coupon }
    this.setState(state)
  }

  handleReceiveCouponError() {
    let card = this.state.card
    let coupon = this.state.coupon
    let expiration = this.state.expiration

    coupon.amount_off = ""
    coupon.percent_off = ""

    let state = { card, expiration, coupon }
    this.setState(state)
  }

  handleCancel() {
    this.setState(this.initialState())
    this.props.onCancel()
  }

  render() {
    const form = this.props.form
    const {
      showModal,
      modalTitle,
      total,
      interval,
      customer,
      isGroup,
      groupCoupon,
      groupCouponLabel,
      pricePerActive
    } = this.props

    const submitBtnClass = Classnames({
      submitting: form.submitting,
      "btn-main-blue": !form.success,
      "btn-main-green": form.success
    })

    const circleStyle = {
      strokeDasharray: "240px, 240px",
      strokeDashoffset: "480px"
    }
    const pathStyle = {
      strokeDasharray: "50px, 50px",
      strokeDashoffset: "0px"
    }
    const fullWidth = {
      width: "100% ",
      textAlign: "center"
    }
    const errorsBox = {
      width: "100% ",
      textAlign: "center",
      color: "#d02f2f",
      marginTop: "15px"
    }
    const btnInlineStyle = {
      width: "100%",
      height: "45px",
      fontSize: "18px"
    }

    const checkmark = (
      <span className="icon icon--order-success inlinesvg svg">
        <svg width="26px" height="26px">
          <g fill="none" stroke="#FFFFFF" stroke-width="2">
            <circle cx="13" cy="13" r="12" style={circleStyle} />
            {/*<path d="M19.417,37.778l9.93,9.909l20.444-22.393" style={pathStyle}></path>*/}
            <path d="M5.817,13.778l4.93,4.909l9.444-11.393" style={pathStyle} />
          </g>
        </svg>
      </span>
    )

    const totalFieldClass = Classnames({
      "display-none": !this.props.totalField,
      "margin-top": true
    })

    var buttonContent
    if (form.success) {
      buttonContent = checkmark
    } else {
      buttonContent = form.submitting
        ? this.props.buttonTitleSubmitting
        : this.props.buttonTitle
    }

    var errorMessage
    if (form.error) {
      errorMessage = form.error_message
    } else {
      errorMessage = null
    }

    // Set GROUP coupon discount row
    let groupCouponDiscountTotal = calculateDiscountFromStripeCoupon(
      groupCoupon,
      total * this.state.quantity
    )

    let groupCouponRow = null
    if (groupCouponDiscountTotal != 0) {
      groupCouponRow = (
        <Row>
          <Col xs={12} sm={12}>
            <FormGroup
              controlId="stripe-form-total"
              className={totalFieldClass}
            >
              <ControlLabel className="total-label">
                {groupCouponLabel}
              </ControlLabel>
              <p className="total-price">
                -${groupCouponDiscountTotal.toFixed(2)}
              </p>
            </FormGroup>
          </Col>
        </Row>
      )
    }

    // Set coupon discount row
    let couponDiscountTotal = calculateDiscountFromStripeCoupon(
      this.state.coupon,
      total * this.state.quantity
    )
    let couponRow = null
    if (couponDiscountTotal > 0) {
      couponRow = (
        <Row>
          <Col xs={12} sm={12}>
            <FormGroup controlId="stripe-form-total">
              <ControlLabel className="total-label">Coupon</ControlLabel>
              <p className="total-price">-${couponDiscountTotal.toFixed(2)}</p>
            </FormGroup>
          </Col>
        </Row>
      )
    }

    // Set plan total row
    let planTotalRow = null
    if (couponRow || groupCouponRow) {
      planTotalRow = (
        <Row>
          <Col xs={12} sm={12}>
            <FormGroup controlId="stripe-form-total">
              <ControlLabel className="total-label">Plan</ControlLabel>
              <p className="total-price">
                ${numeral(
                  parseInt(total).toFixed(2) * this.state.quantity
                ).format("0,0.00")}
              </p>
            </FormGroup>
          </Col>
        </Row>
      )
    }

    // Set totals
    const grandTotal = (
      parseInt(total) * this.state.quantity -
      couponDiscountTotal -
      groupCouponDiscountTotal
    ).toFixed(2)
    var totalPerUserLabel = ""
    if (this.state.quantity > 1) {
      totalPerUserLabel = `(${numeral(grandTotal / this.state.quantity).format(
        "$0,0.00"
      )}/user)`
    }

    return (
      <div className="subscription-form-box">
        <Modal
          bsSize="small"
          show={showModal}
          onHide={this.handleCancel.bind(this)}
          dialogClassName="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSubmit.bind(this)}>
              {!form.submitting &&
                !form.success &&
                isGroup && (
                  <Row>
                    <Col xs={12}>
                      <FieldGroup
                        id="quantity"
                        type="text"
                        label="How many users do you want to prepay?"
                        placeholder={
                          customer.subscription &&
                          customer.subscription.quantity
                        }
                        name="quantity"
                        value={this.state.quantity}
                        onChange={this.handleChange.bind(this)}
                      />
                    </Col>
                  </Row>
                )}

              {!form.submitting &&
                !form.success &&
                !isGroup && (
                  <Row>
                    <CouponField
                      id="coupon"
                      type="text"
                      label="Coupon"
                      placeholder="Enter code (optional)"
                      name="coupon"
                      value={this.state.coupon}
                      onChange={this.handleChange.bind(this)}
                      onReceiveCouponSuccess={this.handleReceiveCouponSuccess.bind(
                        this
                      )}
                      onReceiveCouponError={this.handleReceiveCouponError.bind(
                        this
                      )}
                    />
                  </Row>
                )}

              {!form.submitting &&
                !form.success && (
                  <div>
                    {planTotalRow}
                    {couponRow}
                    {groupCouponRow}

                    <Row>
                      <Col xs={12} sm={12}>
                        <FormGroup>
                          <ControlLabel className="total-label">
                            Total {totalPerUserLabel}
                          </ControlLabel>
                          <p className="total-price">
                            ${numeral(grandTotal).format("0,0.00")}
                          </p>
                          <div className="clear-both" />
                          <HelpBlock>We'll prorate any past charges.</HelpBlock>
                          <div className="clear-both" />
                          {/* {isGroup && (
                            <ControlLabel style={{ marginTop: "5px" }}>
                              You will be charged{" "}
                              {numeral(pricePerActive / 100).format("$0,0.00")}{" "}
                              per user for any additional monthly active users
                              over your{" "}
                              {numeral(this.state.quantity).format("0,0")}{" "}
                              existing prepaid users{" "}
                            </ControlLabel>
                          )} */}
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                )}

              <div className="full-width-center-text" style={fullWidth}>
                <Button
                  disabled={form.submitting || form.success}
                  className={submitBtnClass}
                  style={btnInlineStyle}
                  type="submit"
                >
                  {buttonContent}
                </Button>
              </div>
              <div style={errorsBox}>{errorMessage}</div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

UpdateSubscriptionModal.propTypes = {}



// WEBPACK FOOTER //
// ./src/subscriptions/UpdateSubscriptionModal.js